import React, { useState, useEffect, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';

function Extole(props) {
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const addWidthListener = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', addWidthListener);
    return function cleanup() {
      window.removeEventListener('resize', addWidthListener);
    };
  }, []);

  useLayoutEffect(() => {
    (function(c, b, f, k, a) {
      c[b] = c[b] || {};
      for (c[b].q = c[b].q || []; a < k.length; ) f(k[a++], c[b]);
    })(
      window,
      'extole',
      function(c, b) {
        b[c] =
          b[c] ||
          function() {
            b.q.push([c, arguments]);
          };
      },
      ['createZone'],
      0
    );
    extole.createZone({
      name: 'global_footer',
      element_id: 'extole_zone_global_footer',
      data: {
        email: !props.isAuthenticated ? '' : props.user.email,
        first_name: !props.isAuthenticated ? '' : props.user.first_name,
        last_name: !props.isAuthenticated ? '' : props.user.last_name
      }
    });

    (function(c, b, f, k, a) {
      c[b] = c[b] || {};
      for (c[b].q = c[b].q || []; a < k.length; ) f(k[a++], c[b]);
    })(
      window,
      'extole',
      function(c, b) {
        b[c] =
          b[c] ||
          function() {
            b.q.push([c, arguments]);
          };
      },
      ['createZone'],
      0
    );
    extole.createZone({
      name: 'global_header',
      element_id: 'extole_zone_global_header'
    });

    if (windowWidth < 992) {
      //Only on mobile
      (function(c, b, f, k, a) {
        c[b] = c[b] || {};
        for (c[b].q = c[b].q || []; a < k.length; ) f(k[a++], c[b]);
      })(
        window,
        'extole',
        function(c, b) {
          b[c] =
            b[c] ||
            function() {
              b.q.push([c, arguments]);
            };
        },
        ['createZone'],
        0
      );
      extole.createZone({
        name: 'mobile_menu',
        element_id: 'extole_zone_mobile_menu',
        data: {
          email: !props.isAuthenticated ? '' : props.user.email,
          first_name: !props.isAuthenticated ? '' : props.user.first_name,
          last_name: !props.isAuthenticated ? '' : props.user.last_name
        }
      });
    }
  }, [location]);

  return <div />;
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth.user
  };
};

const mapDispatchToProps = dispatch => ({});

const connecter = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default connecter(Extole);
